import Aos from "aos";
import { useEffect } from "react";

const securityFeatures = [
  "BVN verification",
  "Biometric authentication",
  "Encrypted transactions",
  "Real-time notifications",
];

const BankvoleSecuritySection = () => {
  useEffect(() => {
        Aos.init({
            duration: 1000,
        });
    }, []);
  return (
    <section className="bv-security">
      <div className="bv-security-left" data-aos="zoom-in" data-aos-duration="1000" data-aos-delay="200">
        <img
          src={`${process.env.PUBLIC_URL}/assets/img/bankvole-security.png`}
          alt="Bankvole security illustration"
          className="bv-security-img"
        />
      </div>

      <div className="bv-security-right" data-aos="fade-up" data-aos-duration="1000">
        <h2 className="bv-security-title">Your security comes first.</h2>
        <p className="bv-security-text">
          Your financial security is our priority. Bankvole protects your
          account with BVN verification, biometric authentication, encrypted
          transactions and real-time notifications—giving you confidence
          every step of the way.
        </p>
        <div className="bv-security-grid">
          {securityFeatures.map((feature) => (
            <span key={feature} className="bv-security-chip">
              {feature}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BankvoleSecuritySection;
